/**
 * ScheduleSection.tsx
 * 貸出日時, 返却日時, 来店リクエスト時間, 返却リクエスト時間
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import FieldDisplay from '../shared/FieldDisplay';
import { isoToLocalInput } from '../../../lib/dateUtils';

const SCHEDULE_FIELDS = ['start_date', 'end_date'] as const;
const REQUEST_TIME_FIELDS = ['request_coming_time', 'request_returning_time'] as const;

export default function ScheduleSection({
  data,
  onChange,
  disabled,
  onOpenEdit,
  onOpenEditMulti,
}: SectionProps) {
  const startDisplay = (isoToLocalInput(data.start_date) || '').replace('T', ' ');
  const endDisplay = (isoToLocalInput(data.end_date) || '').replace('T', ' ');

  return (
    <>
      <SectionHeader title="スケジュール" />
      <FieldDisplay
        label="利用期間"
        displayValue={startDisplay && endDisplay ? `${startDisplay} ～ ${endDisplay}` : undefined}
        value={startDisplay && endDisplay ? `${startDisplay} ～ ${endDisplay}` : null}
        fields={SCHEDULE_FIELDS}
        onClick={() =>
          onOpenEditMulti?.('利用期間', [
            { field: 'start_date', label: '貸出日時', type: 'datetime-local' },
            { field: 'end_date', label: '返却日時', type: 'datetime-local' },
          ])
        }
      />
      <FieldDisplay
        label="希望時間"
        displayValue={`${data.request_coming_time || '未設定'} ～ ${data.request_returning_time || '未設定'}`}
        value={data.request_coming_time || data.request_returning_time || null}
        fields={REQUEST_TIME_FIELDS}
        onClick={() =>
          onOpenEditMulti?.('希望時間', [
            { field: 'request_coming_time', label: '来店リクエスト時間', type: 'time' },
            { field: 'request_returning_time', label: '返却リクエスト時間', type: 'time' },
          ])
        }
      />
    </>
  );
}
